// extracted by mini-css-extract-plugin
module.exports = {"icon":"LoadingIcon_icon__1hDrs","rotate":"LoadingIcon_rotate__pYqvt"};